import React, { Component, Fragment } from "react";
import InferenceForecaster from "../Context/Components/InferenceForecaster";
import RuleProvider, { RuleContext } from "../Context/RuleProvider";
import MiniPopup from "./MiniPopup";

// RuleHypothesisModal n'est appelé que par ButtonRuleMaker

class RuleModal extends Component {
  constructor() {
    super();
    this.state = {
      futureHypothesis: "",
    };
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleCloseModal() {
    this.props.valueInference.changeStorageBoolean(); // il n'est plus possible de pusher dans storedInferences + storedInferences est vidé
    this.props.valueInference.setRuleModal(false);
    this.resetHypothesis();
  }

  addToFutureHypothesis = (newChar) => {
    let copyFutureHypothesis = this.state.futureHypothesis;
    copyFutureHypothesis += newChar;
    console.log("grmbl", copyFutureHypothesis);
    InferenceForecaster(
      copyFutureHypothesis, // le contenu de la future hypothèse
      "", // le numéro de l'inférence répétée (c'est vide dans le cas d'une hypothèse)
      "hyp", // le nom de la règle, toujours "rep" dans ce cas
      this.props.valueInference
    );
    this.setState({ futureHypothesis: copyFutureHypothesis });
  };

  showCharacters = () => {
    let everyPossibleCharacter = [
      ["~", "∧", "∨", "⊻", "⊃", "⊅", "≡", "↑", "↓"],
      ["p", "q", "r", "s"],
      ["(", ")"],
    ];
    let interfaceToMakeAnHypothesis = [];
    for (let i = 0; i < everyPossibleCharacter.length; i++) {
      let subInterface = [];
      for (let j = 0; j < everyPossibleCharacter[i].length; j++) {
        subInterface.push(
          <li
            key={subInterface.length}
            className="rule-modal-hypothesis-button-character selectable"
            onClick={() => {
              this.addToFutureHypothesis(everyPossibleCharacter[i][j]);
            }}
          >
            {everyPossibleCharacter[i][j]}
          </li>
        );
      }
      interfaceToMakeAnHypothesis.push(
        <ul key={interfaceToMakeAnHypothesis.length}>{subInterface}</ul>
      );
    }

    return (
      <div className="rule-modal-all-button-hypothesis">
        {interfaceToMakeAnHypothesis}
      </div>
    );
  };

  makeHypothesis = (valueRuleContext, hypothesisItself) => {
    if (2 === 1 + 1) {
      // il faudrait des conditions pour vérifier que l'utilisateur n'a pas rentré n'importe quoi
      // if (//   /^\s*(~*\(?[a-z]+(\s*[∧∨⊻⊃⊂≡↓↑⊅⊄]\s*~*\(?[a-z]+\)?)?\)?)\s*([∧∨⊻⊃⊂≡↓↑⊅⊄]\s*~*\(?[a-z]+(\s*[∧∨⊻⊃⊂≡↓↑⊅⊄]\s*~*\(?[a-z]+\)?)?\)?)\s*$/.test(hypothesisItself)
      const inferenceToAdd = {
        itself: hypothesisItself,
        numberCommentary: "",
        commentary: "hyp",
      };
      this.props.valueInference.setJournal(
        "Hypothèse créée : " + inferenceToAdd.itself,
        "rule-journal"
      );
      valueRuleContext.addInferenceFromRule(
        inferenceToAdd,
        "nouvelle hypothèse"
      );
      // pour être créée, l'hypothèse part d'ici, puis va à addInferenceFromRule de RuleProvider, puis va à addInference de InferenceProvider
      this.handleCloseModal();
    } else {
      this.props.valueInference.setJournal(
        "La syntaxe logique de cette expression n'est pas correcte, d'après le code du site.",
        "error-journal"
      );
    }
  };

  removeLastCharacter = () => {
    let copyFutureHypothesis = [...this.state.futureHypothesis];
    copyFutureHypothesis = copyFutureHypothesis.slice(0, -1); // on extrait une partie du tableau, la première en partant de la fin (d'où le "-1")
    copyFutureHypothesis = copyFutureHypothesis.join("");
    this.setState((state) => ({
      futureHypothesis: copyFutureHypothesis,
    }));
  };

  resetHypothesis = () => {
    const empty = [];
    this.setState((state) => ({
      futureHypothesis: empty,
    }));
  };

  render() {
    // let ruleModalClassName = "";
    // if (!this.props.valueInference.ruleModalShown.normal) {
    //   ruleModalClassName = " hidden";
    // }
    return (
      <RuleProvider
        valueInference={this.props.valueInference}
        // Deducer reçoit le value de InferenceProvider puis l'envoie à ButtonRuleMaker, qui l'envoie à RuleHypothesisModal, qui l'envoie à RuleProvider
      >
        <RuleContext.Consumer>
          {(value) => (
            <Fragment>
              <section className="rule-modal-window">
                <div
                  className="rule-modal-ruleName"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    // justifyContent: "space-between",
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <p>{this.props.ruleName}</p>
                  <div
                    style={{
                      position: "absolute",
                      marginLeft: "250px",
                      fontSize: "14px",
                      opacity: "0.8",
                    }}
                  >
                    {
                      <MiniPopup
                        iconClass={"icon fas fa-question-circle"}
                        text={
                          "Vous pouvez créer une hypothèse avec cette règle. Entrez une expression logique dans la zone de texte (à la souris pour le moment) puis validez-la. (Pour le moment, le code ne vérifie pas si votre expression respecte la syntaxe logique. Ce sera rajouté plus tard, avec une explication succincte ici, de ce que c'est.)"
                        }
                      />
                    }
                  </div>
                </div>

                <p className="rule-modal-ruleInstruction">
                  {this.props.instruction}
                </p>
                <ul className="typable-text">
                  {this.state.futureHypothesis}
                  <p className="blinking">_</p>
                </ul>
                {this.showCharacters(value)}
                {/* {this.props.valueInference.ruleModalChoiceContent} */}
                <div className="rule-modal-all-buttons">
                  <p
                    className="rule-modal-button"
                    onClick={() => {
                      this.removeLastCharacter(
                        value,
                        this.state.futureHypothesis
                      );
                    }}
                  >
                    <i className="fas fa-long-arrow-alt-left icon" />
                  </p>
                  <p
                    className="rule-modal-button"
                    onClick={() => {
                      if (this.state.futureHypothesis.length > 0)
                        this.makeHypothesis(value, this.state.futureHypothesis);
                    }}
                  >
                    <i className="fas fa-check-square" />
                  </p>
                  <p
                    className="rule-modal-button"
                    onClick={() => {
                      this.resetHypothesis();
                    }}
                  >
                    <i className="fas fa-eraser" />
                  </p>
                  <p
                    className="rule-modal-button"
                    onClick={this.handleCloseModal}
                  >
                    <i className="fas fa-times-circle" />
                  </p>
                </div>
              </section>
              {/* </ReactModal> */}
            </Fragment>
          )}
        </RuleContext.Consumer>
      </RuleProvider>
    );
  }
}

export default RuleModal;



// WEBPACK FOOTER //
// ./src/components/Modals and Popovers/RuleHypothesisModal.js